import { Flex, FormLabel } from '@chakra-ui/react';
import { memo, useCallback } from 'react';

import { ToolbarNumberInput } from '../../Toolbar/ToolbarNumberInput';

interface OpacityInputProps {
  opacity: number;
  fontSize?: string;
  onChange: (newOpacity: number) => void;
}

export const OpacityInput = memo(({ opacity, onChange, fontSize = 'xs' }: OpacityInputProps) => {
  const handleOpacityChange = useCallback(
    (newOpacity: number) => {
      onChange(newOpacity);
    },
    [onChange],
  );

  return (
    <Flex justifyContent='center' alignItems='flex-start'>
      <FormLabel mt={1} htmlFor={'opacity-input'} textAlign='center' fontWeight='medium' fontSize={fontSize}>
        Opacity
      </FormLabel>
      <ToolbarNumberInput
        label=''
        value={Math.round(opacity * 100)}
        onChange={handleOpacityChange}
        min={0}
        max={100}
        precision={0}
        id='opacity-input'
        suffix='%'
        triggerBlurOnUnmount={false}
      />
    </Flex>
  );
});
OpacityInput.displayName = 'OpacityInput';
